module.exports = __webpack_public_path__ + "img/4.031f17c8.png";